export default "__VITE_ASSET__B5yx1M1j__"